import { Link } from 'react-router-dom';
import { gaseosasProducts } from '../../mocks/gaseosas';
import { useCart } from '../../context/CartContext';

export default function GaseosasPage() {
  const { addToCart } = useCart();

  const formatPrice = (price: number) => {
    if (typeof price !== 'number' || isNaN(price)) return '0';
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const handleCotizar = (e: React.MouseEvent, productName: string, unitPrice: number, unitsPerPack: number) => {
    e.preventDefault();
    e.stopPropagation();
    const packPrice = unitPrice * unitsPerPack;
    const message = `Hola, quiero cotizar el producto: ${productName} - Precio pack: $${formatPrice(packPrice)}`;
    window.open(`https://wa.me/56912345678?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleAddToCart = (e: React.MouseEvent, product: typeof gaseosasProducts[0]) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id: product.id,
      name: product.name,
      image: product.image,
      packPrice: product.unitPrice * product.unitsPerPack,
      unitsPerPack: product.unitsPerPack,
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="bg-black text-white py-6">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <div>
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <i className="ri-arrow-left-line text-lime-400 text-xl"></i>
              <span className="text-gray-400 text-sm">Volver al inicio</span>
            </Link>
            <h1 className="text-3xl font-bold mt-2">Gaseosas</h1>
            <p className="text-gray-300 mt-1">Catálogo Mayorista</p>
          </div>
          <img src="https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/9a712df9f4520947901c304b55b2e414.png" alt="ACI Distribución" className="h-12 w-auto hidden md:block" />
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-12">
        <div className="bg-amber-50 border-l-4 border-amber-500 p-6 mb-12 rounded-lg">
          <p className="text-gray-800 text-lg font-medium">
            📌 Venta mínima por pack. El precio unitario es solo referencial y no corresponde al mínimo de venta.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop="true">
          {gaseosasProducts.map((product) => (
            <Link
              key={product.id}
              to={`/producto/gaseosas-${product.id}`}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer block"
            >
              <div className="w-full h-80 bg-gray-50 flex items-center justify-center p-6">
                <img src={product.image} alt={product.name} title={`${product.name} - Gaseosa Mayorista`} className="w-full h-full object-contain" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{product.name}</h3>
                <div className="bg-gray-50 rounded-lg p-4 mb-4 space-y-2">
                  <div className="flex items-center text-gray-700">
                    <i className="ri-box-3-line text-lime-600 mr-2 text-lg"></i>
                    <span className="text-sm font-medium">Unidades por pack: <strong>{product.unitsPerPack} unidades</strong></span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <i className="ri-archive-line text-lime-600 mr-2 text-lg"></i>
                    <span className="text-sm font-medium">Tipo de empaque: <strong>{product.packagingType}</strong></span>
                  </div>
                </div>
                <div className="space-y-3 mb-6">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Precio unitario (referencial):</span>
                    <span className="text-gray-700 font-medium">${formatPrice(product.unitPrice)}</span>
                  </div>
                  <div className="bg-lime-500 rounded-lg p-3 flex justify-between items-center">
                    <span className="text-black font-semibold">Precio pack (mínimo de venta):</span>
                    <span className="text-black font-bold text-xl">${formatPrice(product.unitPrice * product.unitsPerPack)}</span>
                  </div>
                  {product.palletPrice && (
                    <div className="flex justify-between items-center text-sm">
                      <span className="text-gray-600">Precio pallet:</span>
                      <span className="text-lime-600 font-bold">${formatPrice(product.palletPrice)}</span>
                    </div>
                  )}
                </div>
                <div className="flex gap-3">
                  <button onClick={(e) => handleCotizar(e, product.name, product.unitPrice, product.unitsPerPack)} className="flex-1 bg-white border-2 border-lime-500 text-lime-600 py-3 rounded-lg font-semibold hover:bg-lime-50 transition-colors whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                    <i className="ri-whatsapp-line text-lg"></i>
                    Cotizar
                  </button>
                  <button onClick={(e) => handleAddToCart(e, product)} className="flex-1 bg-black text-white py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                    <i className="ri-shopping-cart-line text-lg"></i>
                    Comprar
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>

      <footer className="bg-gray-100 mt-20 py-8">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-600 text-sm">
          <p>© 2025 ACI Distribución - Abarca y Castillo Distribución SpA. Todos los derechos reservados.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-lime-600 transition-colors mt-2 inline-block">Powered by Readdy</a>
        </div>
      </footer>
    </div>
  );
}
